<!-- <div class="ui orange inverted segment centered aligned">

</div> -->
<sui-message class="attached negative" *ngIf="showMessage">
    <div class="content">
        <p style="text-align:center">The Nigerian Communications Commission wishes to inform all stakeholders of the harmonized Pricing Scheme for Type Approval of Telecommunications Equipment, which shall take effect from July 1, 2021. <br/> Click <a target="_blank" style="font-weight:bold" href="https://ncc.gov.ng/media-centre/public-notices/975-new-type-approval-pricing-scheme">here</a> to view the harmonized pricing scheme.
            <br/> Please Note: All pending online applications after July 1st 2021 will be invoiced at the new rate </p>
    </div>
</sui-message>
<sui-message class="attached info" *ngIf="verificationStatus">
    <div class="content">
        <p style="text-align:center"[innerHTML]="verificationStatus"> </p>
    </div>
</sui-message>
<sui-message class="attached warning" *ngIf="!isEmailVerified">
    <div class="content">
        <p style="text-align:center">Confirm your email address. A confirmation message was sent to <strong>{{user.appUserEmail}}</strong>. <button class="ui mini  blue button" (click)="resend()"> Resend confirmation</button> <a [routerLink]="['',modulet,'settings','profile']">Update email address</a></p>
    </div>
</sui-message>

<sui-message class="attached warning" *ngIf="!isOrganizationEmailVerified">
    <div class="content">
        <p style="text-align:center">Confirm your company email address. A confirmation message was sent to <strong>{{organization.jpaContractor.companyContactEmail}}</strong>. <button class="ui mini  blue button" (click)="resendCompany()"> Resend confirmation</button> <a [routerLink]="['',modulet,'settings','organization']">Update email address</a></p>
    </div>
</sui-message>

<sui-message class="attached negative" *ngIf="error">
    <div class="content">
        <p style="text-align:center">{{error}}</p>
    </div>
</sui-message>
<sui-message class="attached positive" *ngIf="success">
    <div class="content">
        <p style="text-align:center">{{success}}</p>
    </div>
</sui-message>

    <sui-dimmer class="inverted page" [isDimmed]="loading">
        <div class="ui text loader">please wait...</div>
    </sui-dimmer>